import { observeElement } from '@uvocore-front/utils';
import '../../components/Calculator/CalculatorDefault';
import '../../components/Calculator/CalculatorShort';
import '../../components/ImagesLazyLoading';
import '../../components/NotifyWidget';
import '../../all_pages/js/dropdown';
import '../../all_pages/js/samples';
import '../../all_pages/js/scrollTo';
import '../../all_pages/js/testimonials';
import '../../all_pages/js/toggleMenu';
import './headerScroll';

import Accordion from '../../components/Accordion';

observeElement({
  element: '.AccordionBox',
  marginValue: 300,
  callback: () => {
    Accordion();
  },
});

window.addEventListener('load', () => {
  const hrefElements = document.querySelectorAll('[data-href]');
  const overlay = document.querySelector('.Overlay');
  const hamburger = document.querySelector('.ToggleMenu');
  const menu = document.querySelector('.Menu__wrapper');

  if (hrefElements) {
    Array.prototype.slice.call(hrefElements).forEach((el) => {
      el.addEventListener('click', (e) => {
        const destinationOffset = document.getElementById(e.target.dataset.href).offsetTop - 70;

        window.scroll({
          behavior: 'smooth',
          left: 0,
          top: destinationOffset,
        });

        overlay.classList.remove('show');
        hamburger.classList.remove('is-active');
        menu.classList.remove('visible');
        document.querySelectorAll('.no-scroll').forEach((element) => {
          element.classList.remove('no-scroll');
        });
      });
    });
  }
});
